import React from 'react';
import { Image } from '../../../../../wag-react/next-components/image';
import { WalkerOfferedServicesItem, WalkerReviews, WalkerServiceAddons, WalkerServiceCategoryGallery, WalkerSpecialtiesV6 } from '../../../../../types/api';
import { WalkerSpecialty } from './WalkerSpecialties';
import { serviceAssetMap } from '../assets';
import WalkerServiceCollapsible from './WalkerServiceCollapsible';
import { ServiceList } from '../ServiceList';
import { formatPrice } from '../helpers/formatPrice';
import { capitalizeFirstLetter } from '../../../../OvernightServicePreferencesContainer/helpers';
import { WalkerSectionContainer } from './WalkerSectionContainer';
import { formatSpecialtySlug } from '../helpers/formatSpecialtySlug';
import { WalkerServiceReview } from '../../WalkerReviews/WalkerServiceReview';
import { Box } from '../../../../../wag-react/next-components/box';
import { Typography } from '../../../../../wag-react/components/Typography';
type Props = {
  walkerService: WalkerOfferedServicesItem;
  specialties: WalkerSpecialtiesV6;
  images: WalkerServiceCategoryGallery['items'];
  serviceAddons: WalkerServiceAddons;
  reviews: WalkerReviews['items'];
};
export const WalkerService = ({
  walkerService,
  specialties,
  serviceAddons,
  reviews,
  images
}: Props) => <Box display="flex" flexDirection="column" py={[2, 3]} data-sentry-element="Box" data-sentry-component="WalkerService" data-sentry-source-file="WalkerService.tsx">
    <WalkerSectionContainer containerProps={{
    pt: 0
  }} data-sentry-element="WalkerSectionContainer" data-sentry-source-file="WalkerService.tsx">
      <Typography color="#272727" variant="body1" m={0} fontFamily="muli" fontSize="14px" data-sentry-element="Typography" data-sentry-source-file="WalkerService.tsx">
        {walkerService?.serviceTypes?.[0].description}
      </Typography>
    </WalkerSectionContainer>
    <WalkerSectionContainer title="Rates/Services" data-sentry-element="WalkerSectionContainer" data-sentry-source-file="WalkerService.tsx">
      <ServiceList containerProps={{
      width: '100%'
    }} data-sentry-element="ServiceList" data-sentry-source-file="WalkerService.tsx">
        {walkerService?.serviceTypes?.map(serviceType => <Box key={serviceType.serviceType} px="14px" py="4px" display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="body1" color="#272727" fontSize="14px" width="100" fontFamily="muliBold">
              {formatSpecialtySlug(serviceType?.serviceType)}
            </Typography>

            <Typography variant="body1" fontSize="14px" fontFamily="muliBold" color="#272727">
              {formatPrice(serviceType?.price?.amount)}
            </Typography>
          </Box>)}
      </ServiceList>
    </WalkerSectionContainer>

    {specialties?.flags?.length ? <WalkerSectionContainer title="Specialties">
        {specialties.flags.map(specialty => specialty.selected && <WalkerSpecialty key={specialty.slug} containerProps={{
      width: '50%'
    }} label={specialty.slug} />)}
      </WalkerSectionContainer> : null}

    {images?.length ? <WalkerSectionContainer title="What to expect/images">
        {images.map(photo => <Image key={photo.url} alt="Service image" src={photo.url} height="130px" width="32%" objectFit="cover" />)}
      </WalkerSectionContainer> : null}

    {serviceAddons?.items?.length ? <WalkerSectionContainer title="Add ons">
        {serviceAddons?.items?.map(serviceAddon => <WalkerServiceCollapsible addons rootClassName="mb-4" key={serviceAddon.addonCategory} title={<Box display="flex" alignItems="center" py={[2]} px={2}>
                <Image width="18px" height="18px" mr={2} src={serviceAssetMap[serviceAddon.addonCategory]?.icon} alt="Service Addon Icon" />
                <Typography m={0} color="#272727" fontFamily="muliSemiBold" fontSize="16px">
                  {capitalizeFirstLetter(serviceAddon.addonCategory)}
                </Typography>
              </Box>} content={<ServiceList containerProps={{
      mt: ['10px', '16px']
    }}>
                {serviceAddon?.addons?.map(addon => <Box key={addon.displayName} display="flex" justifyContent="space-between" alignItems="center" px={[3, '22px']} py="2px">
                    <Typography m={0} color="#272727" fontFamily="muliSemiBold" fontSize="16px">
                      {addon.displayName}
                    </Typography>
                    <Typography variant="body1" fontSize="14px" fontFamily="muliBold" color="#272727">
                      {formatPrice(addon.price.amount)}
                    </Typography>
                  </Box>)}
              </ServiceList>} />)}
      </WalkerSectionContainer> : null}

    {reviews?.length ? <WalkerSectionContainer title={`${serviceAssetMap[walkerService.serviceCategory]?.title} Reviews`}>
        <Box display="flex" flexDirection="column" width="100%" style={{
      rowGap: '20px'
    }}>
          {reviews.map((review, i) => <WalkerServiceReview key={String(review.firstName + i)} review={review} />)}
        </Box>
      </WalkerSectionContainer> : null}
  </Box>;